<template>
  <div>
    <button
      id="update-button"
      class="update__header-button"
      v-bind:class="{ 'update__header-button--mob': isMobile }"
      type="button"
      v-on:click="switchIsShow(); reachGoal()">
      <span v-if="!isMobile">Что нового</span>
    </button>
    <v-dialog
      :value="isShow"
      content-class="update-modal"
      max-width="700px"
      v-on:click:outside="switchIsShow()">
      <v-card
        class="update-modal__wrapper">
        <button
          v-on:click="switchIsShow"
          type="button"
          class="update-modal__cross"
        />
        <v-card-title>
          <h3 class="update-modal__title">Что нового</h3>
        </v-card-title>
        <v-tabs
          v-model="selectedIndexItem"
          background-color="transparent"
          color="basil"
          center-active
          grow
          ref="tabs">
          <v-tab
            v-for="item in listUpdates"
            v-bind:key="item.id">
            <h3>{{item.title}}</h3>
          </v-tab>
        </v-tabs>
        <v-tabs-items
          class="update-modal__items"
          v-model="selectedIndexItem">
          <v-tab-item
            v-for="item in listUpdates"
            v-bind:key="item.id"
            class="update-modal__item">
            <update-item
              v-bind:update="item"
              v-bind:is-show-next-button="isShowNextButton"
              v-bind:is-last-item="isLastItem"
              v-on:next-item="onNextPage"
              v-on:redirect="onRedirect"
              v-on:close="switchIsShow"
              v-on:update="onUpdateVote"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UpdateItem from '@/components/UpdateItem.vue';
import mobileMixin from '@/mixins/mobileMixin';
import { GOAL_VIEW_UPDATES_APP } from '@/plugins/metric';

/**
 * @description Название события обновления оценки обновления.
 * @type {string}
 */
const EVENT_NAME_UPDATE_VOTE = 'update-vote';

export default {
  name: 'UpdatesModal',
  components: { UpdateItem },
  mixins: [
    mobileMixin,
  ],
  computed: {
    /**
     * Показывать ли кнопку "Далее"
     * @type boolean
     */
    isShowNextButton() {
      return this.listUpdates.length > 1;
    },
    /**
     * @description Последний элемент.
     * @returns {boolean}
     */
    isLastItem() {
      return (this.listUpdates.length - 1) === this.selectedIndexItem;
    },
    /**
     * @description Идентификатор выбранного обновления.
     * @returns {number}
     */
    selectedUpdateId() {
      return this.listUpdates[this.selectedIndexItem].id;
    },
  },
  props: {
    /**
     * @description Список нововведений.
     * @type Array
     */
    listUpdates: {
      type: Array,
      required: true,
    },
    /**
     * @description Начальное значения просмотра модального окна.
     * @type {Boolean}
     */
    isShowInit: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      /**
       * Показать модальное окно
       * @type boolean
       */
      isShow: this.isShowInit,
      /**
       * Индекс выбранного элемента
       * @type number
       */
      selectedIndexItem: 0,
    };
  },
  methods: {
    /**
     * @description Включить\выключить окно
     * @returns {void}
     */
    switchIsShow() {
      this.isShow = !this.isShow;
    },
    /**
     * @description Обработать событие перенаправления
     * @param link {string}
     * @returns {void}
     */
    onRedirect(link) {
      this.switchIsShow();
      const isHasPath = this.$router.options
        .routes
        .filter((route) => route.path === link).length > 0;
      const isSamePath = this.$route.path !== link;
      if (isHasPath && isSamePath) {
        this.$router.push({ path: link });
      }
    },
    /**
     * @description Обработать событие переключиться на следующую страницу
     * @returns {void}
     */
    onNextPage() {
      this.selectedIndexItem += 1;
    },
    /**
     * @description Обработать событие переключиться на предыдующую страницу
     * @returns {void}
     */
    onPreviousPage() {
      this.selectedIndexItem -= 1;
    },
    /**
     * @description Обработать обновление оценки обновления.
     * @param {number} updateId
     * @param {string} vote
     * @returns {void}
     */
    onUpdateVote(updateId, vote) {
      this.$emit(EVENT_NAME_UPDATE_VOTE, updateId, vote);
    },
    /**
     * @description Обработать достижение цели.
     * @returns {void}
     */
    reachGoal() {
      this.$goal(GOAL_VIEW_UPDATES_APP);
    },
    /**
     * @description Обработать открытие диалогового окна.
     * @returns {void}
     */
    onDialogOpen() {
      this.$refs.tabs.$el.querySelector('.v-slide-group__next').addEventListener(
        'click',
        this.onNextPage,
      );
      this.$refs.tabs.$el.querySelector('.v-slide-group__prev').addEventListener(
        'click',
        this.onPreviousPage,
      );
    },
  },
  watch: {
    isShow(value) {
      if (value) {
        this.$nextTick(() => {
          this.onDialogOpen();
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.update {
   &__header-button {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 4px;
    min-width: 140px;
    margin-left: auto;
    padding: 7px 16px;
    font-size: 16px;
    line-height: 19px;
    color: #1EBFBF;
    background-color:  #D6FDFB;
    border: 1px solid transparent;
    border-radius: 15px;
    transition: 0.3s;
    &::before {
      content: '';
      width: 18px;
      height: 18px;
      background: url("@/assets/img/lightning.svg") no-repeat 50%;
      background-size: 18px 18px;
    }
    &--mob {
      min-width: 30px;
      padding: 4px 8px;
      &::before {
        width: 16px;
        height: 16px;
        background-size: 16px 16px;
      }
    }
    &:hover{
      border-color: #1EBFBF;
    }
   }
   &__modal {
    &__control-menu {
      display: flex;
      justify-content: space-between;
    }
    &__slider-status {
      width: 50px;
      height: 25px;
      background-color: black;
    }
  }
}

::v-deep .update-modal {
  position: relative;
  height: 660px;
  max-height: 680px;
  overflow: hidden;
  &__wrapper {
    height: 100%;
    overflow-y: auto;
  }
  &__title {
    font-family: "PT Sans", sans-serif;
  }
  &__items {
    height: 100%;
    max-height: 540px;
  }
  &__item {
    height: 100%;
  }
  &__cross {
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;
    background-image: url("@/assets/img/exit-black.svg");
    background-repeat: no-repeat;
    background-size: contain;
    width: 17px;
    height: 17px;
  }
}

@media screen and (max-width: 960px) {
  .update {
    &__header-button {
      margin-left: 0;
    }
  }
}

@media screen and (max-width: 480px) {
  ::v-deep .update-modal {
    height: 80dvh;
    &__items {
      max-height: 80%;
    }
  }
}

</style>
